import { getLogoBase64, BRAND_NAVY_RGB, BRAND_GREEN_RGB, COMPANY_BRAND } from '../utils/brandAssets';

/**
 * Certificado de conclusão (PDF A4 paisagem, jsPDF carregado sob demanda).
 * Dados vêm do backend (`course.certificate`), que só os envia para
 * matrícula aprovada — o nome do aluno sai do cadastro, não do navegador.
 */
export async function downloadCertificate(course) {
  const cert = course.certificate;
  if (!cert) return;
  const { jsPDF } = await import('jspdf');
  const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
  const W = doc.internal.pageSize.getWidth();
  const H = doc.internal.pageSize.getHeight();

  // Moldura
  doc.setDrawColor(...BRAND_NAVY_RGB);
  doc.setLineWidth(1.2);
  doc.rect(8, 8, W - 16, H - 16);
  doc.setDrawColor(...BRAND_GREEN_RGB);
  doc.setLineWidth(0.6);
  doc.rect(12, 12, W - 24, H - 24);

  const logo = await getLogoBase64();
  if (logo) doc.addImage(logo, 'JPEG', W / 2 - 14, 20, 28, 28);

  doc.setTextColor(...BRAND_NAVY_RGB);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(30);
  doc.text('CERTIFICADO DE CONCLUSÃO', W / 2, 64, { align: 'center' });

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(14);
  doc.setTextColor(89, 89, 89);
  doc.text('Certificamos que', W / 2, 80, { align: 'center' });

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(24);
  doc.setTextColor(...BRAND_NAVY_RGB);
  doc.text(String(cert.learner_name || ''), W / 2, 94, { align: 'center' });
  doc.setDrawColor(...BRAND_GREEN_RGB);
  doc.setLineWidth(0.8);
  doc.line(W / 2 - 70, 98, W / 2 + 70, 98);

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(14);
  doc.setTextColor(89, 89, 89);
  doc.text('concluiu com aproveitamento o curso', W / 2, 110, { align: 'center' });

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(18);
  doc.setTextColor(...BRAND_NAVY_RGB);
  const titleLines = doc.splitTextToSize(course.title, W - 70);
  doc.text(titleLines, W / 2, 122, { align: 'center' });

  const details = [];
  if (course.workload_hours) details.push(`Carga horária: ${Number(course.workload_hours).toLocaleString('pt-BR')} h`);
  if (cert.final_score !== null && cert.final_score !== undefined) details.push(`Nota final: ${Number(cert.final_score).toLocaleString('pt-BR', { maximumFractionDigits: 2 })}`);
  details.push(`Concluído em ${new Date(cert.completed_at).toLocaleDateString('pt-BR')}`);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(12);
  doc.setTextColor(89, 89, 89);
  doc.text(details.join('   ·   '), W / 2, 122 + titleLines.length * 8 + 6, { align: 'center' });

  doc.setFontSize(10);
  doc.setTextColor(154, 163, 175);
  doc.text(`${COMPANY_BRAND} · DHR Consultoria · Código ${cert.code}`, W / 2, H - 20, { align: 'center' });

  const slug = course.title.normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^\w]+/g, '-').toLowerCase();
  doc.save(`certificado-${slug}.pdf`);
}
